import { PeakSource } from "@/enums/enums";
import { GetLanguageType, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import {
  PaymentModel,
  SalaryBookmarkModel,
  SalaryModel,
  SummarySalaryTableViewModel,
} from "@/model/salary/salaryModel";
import { SalaryTableViewModel } from "@/model/salary/salaryTableViewModel";
import service from "../baseHttpService";
class SalaryService {
  DoCreateSalary(salary: SalaryModel) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: salary,
    };
    return service.peakPayrollAPI.post("/api/Salary/CreateSalary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetBookmarkList() {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
    };
    return service.peakPayrollAPI.post("/api/Salary/GetBookmarkList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoCreateBookmark(bookmark: SalaryBookmarkModel) {
    const _input = {
      merchantId: MerchantId(),
      data: bookmark,
    };
    return service.peakPayrollAPI.post("/api/Salary/CreateBookmark", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoDeletedBookmark(bookmarkId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: bookmarkId,
    };
    return service.peakPayrollAPI.post("/api/Salary/DeleteBookmark", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoEditSalary(salary: SalaryModel) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: salary,
    };
    return service.peakPayrollAPI.post("/api/Salary/UpdateSalary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSalarySuggestionCode(date: string) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: date,
    };

    return service.peakPayrollAPI
      .post("/api/Salary/GetSalarySuggestionCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSalaryTable(tableView: SalaryTableViewModel) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: tableView,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSalaryTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetSalaryDetail(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSalaryDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSalaryInBookmark(bookmarkId: number) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: bookmarkId,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSalaryByBookmarkId", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetLogHistoryDetail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: {
        moduleId: input.moduleId,
        referenceId: input.referenceId,
      },
    };
    return service.peakPayrollAPI.post("/api/Log/GetLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateSalaryPaid(salaryId: number, payment: PaymentModel) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: {
        salaryId: salaryId,
        payment: payment,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/UpdateSalaryPaid", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateSalarySSOPaid(salaryId: number, payment: PaymentModel) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: {
        salaryId: salaryId,
        payment: payment,
      },
    };
    return service.peakPayrollAPI.post("/api/Salary/UpdateSalarySSOPaid", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateSalaryExpense(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/UpdateSalaryExpense", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateSalaryDeleted(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/UpdateSalaryDeleted", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoSendSlipEmail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: { salaryId: input.salaryId, employeeIdList: input.employeeIdList },
    };
    return service.peakPayrollAPI.post("/api/Salary/SendSlipEmail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoSendWhtCertificateEmail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      languageType: GetLanguageType(),
      data: { summarySalaryId: input.summarySalaryId, employeeIdList: input.employeeIdList },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/SendWhtCertificateEmail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId: number) {
    const _input = {
      transactionId: transactionId,
    };
    return service.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByInvoice", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoCreateSummarySalaryPeriod(input: any) {
    const _input = {
      merchantId: MerchantId(),
      languageType: i18n.locale,
      data: {
        fromDate: input.fromDate,
        toDate: input.toDate,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/CreateSummarySalaryPeriod", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSummarySalaryDetail(summarySalaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: summarySalaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSummarySalaryDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVoidSummarySalary(summarySalaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: summarySalaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/VoidSummarySalary", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSalaryTableForSummarySalary(summarySalaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: summarySalaryId,
    };
    return service.peakPayrollAPI
      .post("/api/Salary/GetSalaryTableForSummarySalary", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetWhtCertificateById(input: any) {
    const _input = {
      merchantId: input.merchantId,
      data: input.whtCertificateId,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetWhtCertificateById", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetWhtCertificateByPasscode(input: any) {
    const _input = {
      merchantId: input.merchantId,
      data: {
        whtCertificateId: input.whtCertificateId,
        passcode: input.passcode,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/GetWhtCertificateByPasscode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSummarySalaryTable(input: SummarySalaryTableViewModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSummarySalaryTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPndItemModel(summarySalaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: summarySalaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetPndItemModel", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSalaryCommentLog(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/Salary/GetSalaryCommentLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoAddSalaryCommentLog(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/Salary/AddSalaryCommentLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVoidSalaryCommentLog(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/Salary/VoidSalaryCommentLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVoidPaidPayment(paymentGroupId: number) {
    const _input = {
      merchantId: MerchantId(),
      paymentGroupId: paymentGroupId,
      source: PeakSource.PeakPayroll,
    };
    return service.peakRealTimeAPI.post("/api/Payment/VoidPaidPayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVoidInvoice(transactionId: number) {
    const _input = {
      merchantId: MerchantId(),
      transactionId: transactionId,
      source: PeakSource.PeakPayroll,
    };
    return service.peakRealTimeAPI.post("/api/Transaction/VoidInvoice", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoRecheckDataSalaryExpense(salaryId: number) {
    const _input = {
      salaryId: salaryId,
    };
    return service.peakPayrollAPI
      .post("/api/Salary/RecheckDataSalaryExpense", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoRecheckDataSSOExpense(salaryId: number) {
    const _input = {
      salaryId: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/RecheckDataSSOExpense", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoReInsertSalaryActive(salaryId: number) {
    const _input = {
      salaryId: salaryId,
    };
    return service.peakPayrollAPI.post("/api/Salary/ReInsertSalaryActive", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}
export default new SalaryService();
